<template>
  <div>
    <logo-title
      :hotKeyWords="hotKeyWords"
      url="http://goabroad.xdf.cn/xinban/"
      logoPos="background-position: 4px -410px"
    ></logo-title>
    <swiper></swiper>
    <keep-alive>
      <cart ></cart>
    </keep-alive>
    <main-floor></main-floor>
    <living title="精品直播" :listObj="gobroadLiving"></living>
  </div>
</template>

<script>
import LeftNav from '@/common-components/Channelleftnav'
import LogoTitle from '@/common-components/Logotitle'
import Swiper from './components/swiper/Swiper'
import MainFloor from './components/mainfloor/Mainfloor'
import Living from './components/mainfloor/Living.vue'
import { hotKeyWords } from 'js/gobroad/hotkeywords'
import Cart from '@/common-components/Cart'
export default {
  name: 'gobroad',
  data () {
    return {
      hotKeyWords,
      gobroadLiving: [
        {
          code: 53,
          title: '初中'
        },
        {
          code: 52,
          title: '高中'
        }
      ]
    }
  },
  components: {
    Cart,
    Swiper,
    LeftNav,
    LogoTitle,
    MainFloor,
    Living
  }
}
</script>

<style lang="stylus"></style>



// WEBPACK FOOTER //
// src/pages/gobroad/Gobroad.vue